import React, { Fragment } from 'react';
import { Layout } from 'antd';
import Header from '../Header';
import Content from '../Content';
import Footer from '../Footer';

const MainLayout = ({
  history,
  ContentBody,
}) => {
  return (
    <Fragment>
      <Layout className='layout-wrapper'>
        <Header history={history}/>
        <Content ContentBody={ContentBody}/>
        <Footer />
      </Layout>
    </Fragment>
  );
};

export default MainLayout;